function useFacebookPixel(code: string) {
   if (import.meta.env.SSR) return;

   if (!code) {
      console.error("Facebook Pixel code not provided");
      return;
   }

   // Initialise Facebook Pixel only once when it's undefined to prevent duplicate ID warning
   if (typeof window.fbq === "undefined") {
      (window as Window).loadFacebookPixel(code);
   }
}

// 💭 window.fbq might not exist if:
// 1. the user has an adblocker
// 2. the meta pixel service is disabled on the portal
// 3. the user has disabled third-party cookies (meta pixel)

function trackSignUpStarted(studyId) {
   if (!window.fbq) return;

   window.fbq("trackCustom", `study-${studyId}-signup-start`);
}

function trackSignUpCompleted(studyId) {
   if (!window.fbq) return;

   window.fbq("trackCustom", `study-${studyId}-signup-complete`);
}

function trackStudyJoinState(studyId, state: "joined" | "screenout") {
   if (!window.fbq) return;

   window.fbq("trackCustom", `study-${studyId}-${state}-study`);
}

export { useFacebookPixel, trackSignUpStarted, trackSignUpCompleted, trackStudyJoinState };
